import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { LANGUAGES, LANG_BY_CODE } from "./languages";
import en from "./locales/en.json";

// Dynamically load all locale json files. Vite will inline them.
const modules = import.meta.glob("./locales/*.json", { eager: true }) as Record<string, { default: any }>;
const resources: Record<string, { translation: any }> = {};
for (const path in modules) {
  const code = path.match(/\/([a-z]{2})\.json$/)?.[1];
  if (code) resources[code] = { translation: modules[path].default };
}
// Ensure English fallback always present
resources.en = { translation: en };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: LANGUAGES.map(l => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "nexafx_lang",
    },
    react: { useSuspense: false },
  });

// Apply dir attribute on language change
const applyDir = (lng: string) => {
  const meta = LANG_BY_CODE[lng] || LANG_BY_CODE[lng?.split("-")[0]];
  if (typeof document !== "undefined") {
    document.documentElement.dir = meta?.dir ?? "ltr";
    document.documentElement.lang = meta?.code ?? "en";
  }
};
applyDir(i18n.language);
i18n.on("languageChanged", applyDir);

export default i18n;